import { ClientPolicy } from '../Client'
import { PaymentMethod } from '../PaymentMethod'
import { PaymentType } from '../PaymentType'
import * as api from '../task-detail-api'
import { TransactionType } from '../TransactionType'
import { getCoreDetail, getPayOutDetail } from './common/payout'

export interface PartialSurrender {
  tag: TransactionType.PARTIAL_SURRENDER

  currentSumAssured: string
  newSumAssured: string
  advancePremium: string
  suspenseAmount: string
  loanOverLimit: string
  estimatedPaidSurrender: string

  totalAmount: number
  methods: PaymentMethod[]
  cashOutList?: api.PaymentData.CashOutList
  branchName?: string
}

export const PartialSurrender = (
  poName: string,
  detail: api.PartialSurrender & api.TaskDetailBase,
  clientPolicy: Array<ClientPolicy>,
  branchName?: string
): PartialSurrender => {
  const p = detail.payload
  const coreStatus = getCoreDetail(detail.coreResponseDetail, p.body.cashOutOptions)
  const cashOutList =
    detail.payload && detail.payload.body
      ? detail.payload.body.cashOutOptions?.filter(
          (x) =>
            PaymentType.BANKTRANSFER === x.type ||
            PaymentType.PAID_AT_BANK === x.type ||
            PaymentType.CASH_AT_COUNTER === x.type
        )
      : []
  return {
    tag: TransactionType.PARTIAL_SURRENDER,

    currentSumAssured: p.body.attributesExt.CURRENT_SUM_ASSURED,
    newSumAssured: p.body.attributesExt.NEW_SUM_ASSURED,
    advancePremium: p.body.attributesExt.ADVANCE_PREMIUM,
    suspenseAmount: p.body.attributesExt.SUSPENSE_AMOUNT,
    loanOverLimit: p.body.attributesExt.LOAN_OVER_LIMIT,
    estimatedPaidSurrender: p.body.attributesExt.ESTIMATED_PAID_SURRENDER,

    totalAmount: p.body?.cashOutOptions?.reduce((total, next) => total + (next.paymentOption.amount ?? 0), 0) ?? 0, // missing
    cashOutList: cashOutList,
    branchName: branchName,
    methods: p.body
      ? p.body.cashOutOptions?.map((v, i) => ({
          method: v.type || '-',
          detail: getPayOutDetail(
            {
              type: v.type as PaymentType,
              officeCode:
                (v.type === PaymentType.CASH_AT_COUNTER && v.attributesExt?.PVA_CASH_OUT_OPTION_INFO.officeCode) || '',

              bankAccount: {
                accountName:
                  (v.type === PaymentType.BANKTRANSFER && v.bankAccount?.accountName) ||
                  (v.type === PaymentType.PAID_AT_BANK &&
                    (v.attributesExt?.PAYEE_INFO?.payeeName === ''
                      ? poName
                      : v.attributesExt?.PAYEE_INFO?.payeeName)) ||
                  (v.type === PaymentType.CASH_AT_COUNTER &&
                    (v.attributesExt?.PAYEE_INFO?.payeeName === ''
                      ? poName
                      : v.attributesExt?.PAYEE_INFO?.payeeName)) ||
                  ((v.type === PaymentType.MOMO && v.attributesExt?.PAYEE_INFO?.payeeName) ?? poName) ||
                  '-',
                accountNo:
                  (v.type === PaymentType.BANKTRANSFER && v.bankAccount?.accountNo) ||
                  ((v.type === PaymentType.PAID_AT_BANK && v.attributesExt?.PAYEE_INFO?.idNumber) ??
                    detail.clientNumber) ||
                  ((v.type === PaymentType.CASH_AT_COUNTER && v.attributesExt?.PAYEE_INFO?.idNumber) ??
                    detail.clientNumber) ||
                  ((v.type === PaymentType.MOMO && v.attributesExt?.PAYEE_INFO?.idNumber) ?? detail.clientNumber) ||
                  '-',
                bankName:
                  (v.type === PaymentType.BANKTRANSFER && v.bankAccount?.bankName) ||
                  (v.type === PaymentType.PAID_AT_BANK && v.bankAccount?.bankName) ||
                  '-',
                branchName:
                  (v.type === PaymentType.BANKTRANSFER && branchName) ||
                  (v.type === PaymentType.PAID_AT_BANK && branchName) ||
                  undefined,
                bankCode: '-',
                branchCode: (v.type === PaymentType.BANKTRANSFER && v.bankAccount?.branchCode) || '-'
              },
              phoneNumber: (v.type === PaymentType.MOMO && v.attributesExt?.PAYEE_INFO?.phone) || '',
              issuedDate: (v.type === PaymentType.PAID_AT_BANK && v.attributesExt?.PAYEE_INFO?.issuedDate) || '',
              issuedBy: (v.type === PaymentType.PAID_AT_BANK && v.attributesExt?.PAYEE_INFO?.issuedBy) || '',
              policy: {
                policyNo: v.policy?.policyNo || '-'
              }
            },
            clientPolicy
          ),
          amount: v.paymentOption.amount || 0,
          status: coreStatus[i].status,
          note: coreStatus[i].errorMes,
          action: '-',
          bankCode: v.type === PaymentType.BANKTRANSFER ? v.bankAccount?.bankName || '-' : undefined
        })) || []
      : []
  }
}
